// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2WLZZ","title":"Info_title__fAdWa","selects":"Info_selects__1YNFe","requiredAsterisk":"Info_requiredAsterisk__JNlyL"};